import { render, staticRenderFns } from "./articleDetail.vue?vue&type=template&id=0c6ed0ce&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/common.css?vue&type=style&index=0&id=0c6ed0ce&prod&scoped=true&lang=css&external"
import style1 from "../../../static/css/articleDetail.css?vue&type=style&index=1&id=0c6ed0ce&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ed0ce",
  null
  
)

export default component.exports